import {
  SxProps,
} from '@mui/material';
import moment from 'moment';
import { WrappedGoal } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Goal';
import CustomDrawer, { CustomDrawerProps } from 'src/components/CustomDrawer';
import BadgeBox from 'src/careflow/common/BadgeBox';
import { getSeverityDueDateData } from 'src/careflow/helpers/getSeverityDueDateData';
import { Container, LabelValue, LabelValueProps, Section } from 'src/careflow/care-coordination/task/common/TaskDetailDrawer';

interface GoalDetailDrawerProps extends Omit<CustomDrawerProps, 'title' | 'anchor'> {
  goal?: WrappedGoal | null;
  title?: string;
}

const { valueTextFontSize, blackTextColor,margin5 }: { [k: string]: SxProps } = {
  valueTextFontSize: {
    fontSize: '0.8rem',
  },
  blackTextColor: {
    color: '#212b36',
  },
  margin5: {
    marginRight: '5px',
  },
};

const getFormattedDate = (date: moment.Moment): string => {
  const { formattedDueDate } = getSeverityDueDateData(date);
  if (formattedDueDate === 'N/A') return '';
  return formattedDueDate;
};

const GoalDetailDrawer = ({
  goal,
  title,
  ...props
}: GoalDetailDrawerProps) => {

  const GoalDetails: LabelValueProps[] = [
    { label: 'Category', value: goal?.getPathwayDisplay() ?? goal?.getPathway() ?? null },
    { label: 'Plan Definition', value: goal?.getPlainDescription() ?? null },
    { label: 'Owner', value: goal?.subject?.display ?? null },
    { label: 'Status', value: goal?.lifecycleStatus ?? null},
    { 
      label: 'Achievement Status', 
      value: goal?.getAchievementStatus()?.display 
        ?? goal?.getAchievementStatus()?.code
        ?? null
    },
    { label: 'Start Date', value: getFormattedDate(moment(goal?.startDate ?? null)) },
    { label: 'End Date', value: getFormattedDate(moment(goal?.getEndDate() ?? null))},
    { label: 'Description', value: goal?.getPlainDescription() ?? null },
    { label: 'Comments', value: goal?.getComments() ?? '' },
  ];

  return (
    <CustomDrawer
      {...props}
      title={title ?? ""}
      anchor="right"
      containerSx={{ width: '25vw' }}
      contentContainerSx={{ padding: 0 }}
    >
      <Container sx={{ backgroundColor: '#f4f6f8' }}>
        <Section title="">
          {GoalDetails.map((goalDetail) => (
            <LabelValue key={goalDetail.label} {...goalDetail} />
          ))}
          {goal?.target?.map((item, index) => {
            const measure = item?.measure?.coding?.[0]?.display ?? item?.measure?.coding?.[0]?.code;
            const detailString = item?.detailString;
            const dueDate = getFormattedDate(moment(item?.dueDate) ?? null);
            const itemsBadge = [
              {label: 'Measure', value: measure ?? ""}, 
              {label: 'Due Date', value: detailString ?? ""},
              {label: 'Value', value: dueDate ?? ""}
            ];

            return (
              <BadgeBox
                key={`bbox-${index}`}
                index={index} 
                items={itemsBadge} 
                blackTextColor={blackTextColor} 
                valueTextFontSize={valueTextFontSize}
                titleBadge={'Target'}
              />
            )
          })}
        </Section>
      </Container>
    </CustomDrawer>
  );
};

export default GoalDetailDrawer;
